import { forwardRef } from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import * as svgIcons from '@fortawesome/free-solid-svg-icons';

const FAIcon = forwardRef((props, ref) => {
	let { icon, size = 1 } = props;

	if (!svgIcons[icon]) {
		console.warn(`Kein Fontawsome Icon zu "${icon}" gefunden.`, 'Mögliche Icons:', svgIcons);
		icon = 'faQuestion';
	}

	const {
		icon: [width, height, , , svgPathData]
	} = svgIcons[icon];

	return (
		<SvgIcon {...props} ref={ref} viewBox={`0 0 ${width * size} ${height * size}`}>
			{typeof svgPathData === 'string' ? (
				<path d={svgPathData} />
			) : (
				/**
				 * A multi-path Font Awesome icon seems to imply a duotune icon. The 0th path seems to
				 * be the faded element (referred to as the "secondary" path in the Font Awesome docs)
				 * of a duotone icon. 40% is the default opacity.
				 *
				 * @see https://fontawesome.com/how-to-use/on-the-web/styling/duotone-icons#changing-opacity
				 */
				svgPathData.map((d, i) => <path style={{ opacity: i === 0 ? 0.4 : 1 }} d={d} />)
			)}
		</SvgIcon>
	);
});

export default FAIcon;
